const styles = theme => ({})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Block/styles.js